import React from 'react';
import { Image, View } from 'react-native';
import { logo } from '../platform/brand';
import { Caption } from './ui';

/** A quiet cookbook mark; loading never adds a timed splash delay. */
export default function BrandLogo({ size = 112, loading = false, label = 'Chefi' }: { size?: number; loading?: boolean; label?: string }) {
  return <View style={{ alignItems: 'center', gap: 8 }} accessible accessibilityLabel={label} accessibilityRole={loading ? 'progressbar' : 'image'}>
    <Image source={logo} style={{ width: size, height: size, borderRadius: size * 0.16 }} accessible={false} />
    {loading ? <Caption>{label}</Caption> : null}
  </View>;
}
